(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/coupon.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/coupon.js');

'use strict';

const {
  useContext,
  useState,
  Fragment
} = React;
const {
  finishPlaceReasons,
  couponValues,
  systemTypes
} = svs.racing.common.constants;
const {
  PlayContext
} = svs.racing_game.components.playContext;
const {
  getCouponItemSystemClass,
  couponValueToText
} = svs.racing_game.components.play.Util;
const {
  MiniMeta,
  ParticipantInfo,
  SelectionSummary
} = svs.racing_game.components.play;
const {
  ReactButtonBet: ButtonBet
} = svs.components;
const {
  Button,
  ReactIcon,
  ReactIconButton
} = svs.ui;
const {
  raceOpen,
  raceOngoing,
  raceHasPreliminaryResults,
  raceHasFinalResults
} = svs.racing.common.statusUtil;
const {
  getResultText
} = svs.racing.common.strings;
const raceNotYetOpen = svs.racing.common.statusUtil.raceNotYetOpen;
const {
  useNavigationState
} = svs.racing.navigation;
const UnitCombinedParticipant = _ref => {
  let {
    isDisabled,
    participant,
    index,
    value,
    canceled,
    toggleIndex,
    silksFormattedDate
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing",
    disabled: canceled || isDisabled,
    label: value ? "".concat(couponValueToText(value)) : '',
    onClick: () => toggleIndex(index),
    selected: value && !canceled,
    type: "button"
  }), React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }));
};
const UnitCombinedUnorderedParticipant = _ref2 => {
  let {
    isDisabled,
    participant,
    index,
    value,
    canceled,
    toggleIndex,
    silksFormattedDate
  } = _ref2;
  return React.createElement(React.Fragment, null, React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing",
    disabled: canceled || isDisabled,
    label: "",
    onClick: () => toggleIndex(index),
    selected: value && !canceled,
    type: "button"
  }, value && !canceled && React.createElement(ReactIcon, {
    class: "btn-bet-icon",
    icon: "checkmark"
  })), React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }));
};
const TopRankParticipant = _ref3 => {
  let {
    isDisabled,
    participant,
    index,
    value,
    canceled,
    toggleIndexRank,
    silksFormattedDate
  } = _ref3;
  return React.createElement(React.Fragment, null, React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }), value.map((rankValue, rankIndex) => React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing",
    disabled: canceled || isDisabled
    ,
    key: "".concat(participant.participantId, "-").concat(rankIndex),
    label: "".concat(rankIndex + 1, ":a"),
    onClick: () => toggleIndexRank(index, rankIndex),
    selected: rankValue && !canceled,
    type: "button"
  })));
};
const TopRankPixParticipant = _ref4 => {
  let {
    isDisabled,
    participant,
    index,
    value,
    canceled,
    toggleIndexRank,
    silksFormattedDate,
    disabledRanks,
    disabledRankIndices,
    firstPlaceIsPicked,
    toggleSingleOnFirstPosition,
    isPixPick,
    singleOnFirstPosition,
    isXpertenFetched
  } = _ref4;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "top-rank-pix-participant-holder"
  }, React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }), firstPlaceIsPicked && React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing pad-lock",
    disabled: isXpertenFetched,
    onClick: () => toggleSingleOnFirstPosition(),
    selected: singleOnFirstPosition,
    type: "button"
  }, React.createElement(ReactIcon, {
    class: "btn-bet-icon",
    icon: singleOnFirstPosition ? 'lock-closed' : 'lock-open'
  }))), value.map((rankValue, rankIndex) => {
    const isCustomPick = disabledRanks[rankIndex];
    const rankIsPicked = !rankValue && disabledRankIndices[rankIndex];
    const disableRankAndParticipant = (isCustomPick || rankIsPicked) && !isXpertenFetched;
    return React.createElement(ButtonBet, {
      animated: true,
      branding: "racing",
      className: "coupon-btn-bet-racing".concat(isPixPick(rankIndex, participant.participantNumber) ? ' pix-pick' : ''),
      disabled: canceled || isDisabled || disableRankAndParticipant || isXpertenFetched && !isPixPick(rankIndex, participant.participantNumber)
      ,
      key: "".concat(participant.participantId, "-").concat(rankIndex),
      label: "".concat(rankIndex + 1, ":A"),
      onClick: () => toggleIndexRank(index, rankIndex),
      selected: rankValue && !canceled,
      type: "button"
    });
  }));
};
const WheelParticipant = _ref5 => {
  let {
    isDisabled,
    participant,
    index,
    value,
    canceled,
    toggleIndexBase,
    isLocked,
    silksFormattedDate
  } = _ref5;
  return React.createElement(React.Fragment, null, React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing",
    disabled: isLocked || canceled || isDisabled,
    label: "U",
    onClick: () => toggleIndexBase(index, true),
    selected: Boolean(value && value.base && !(isLocked || canceled)),
    type: "button"
  }), React.createElement(ButtonBet, {
    animated: true,
    branding: "racing",
    className: "coupon-btn-bet-racing",
    disabled: canceled,
    label: "",
    onClick: () => toggleIndexBase(index, false),
    selected: Boolean(value && value.extra),
    type: "button"
  }, value.extra && !canceled && React.createElement(ReactIcon, {
    class: "btn-bet-icon",
    icon: "checkmark"
  })), React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }));
};
const ResultParticipant = _ref6 => {
  let {
    participant,
    value,
    canceled,
    race,
    silksFormattedDate,
    index
  } = _ref6;
  return React.createElement(React.Fragment, null, (raceHasPreliminaryResults(race) || raceHasFinalResults(race)) && React.createElement("span", {
    className: "meeting-ongoing finished-status-".concat(value.status === finishPlaceReasons.FINISHED)
  }, getResultText(value.place, value.status, participant.canceled)), raceOngoing(race) && React.createElement("span", {
    className: "meeting-ongoing"
  }, "-"), React.createElement(ParticipantInfo, {
    canceled: canceled,
    index: index,
    participant: participant,
    silksFormattedDate: silksFormattedDate
  }));
};
const renderParticipants = (race, engine, isDisabled, selectedParticipantId) => {
  const {
    toggleIndex,
    toggleIndexRank,
    toggleIndexBase,
    toggleSingleOnFirstPosition
  } = engine.actions;

  const {
    getRow,
    getIndexRanksAsBoolArray,
    getIndexAsObject,
    getDisabledRanksAsBoolArray,
    getDisabledRankIndices,
    getFirstPlaceIsPicked,
    getSingleOnFirstPosition,
    isPixPick,
    isXpertenFetched
  } = engine.selectors;
  const row = getRow();
  const systemType = engine.systemType;
  const listItemClass = getCouponItemSystemClass(systemType, race);
  const silksFormattedDate = race.meeting.silksFormattedDate;
  const firstOfAdditionalDistance = [];
  const disabledRankIndices = systemType === systemTypes.TOP_RANK_PIX && getDisabledRankIndices();
  const xpertenFetched = systemType === systemTypes.TOP_RANK_PIX && isXpertenFetched();
  let lockedIndicies;
  if (systemType === systemTypes.WHEEL) {
    lockedIndicies = engine.selectors.getLockedIndices();
  }
  return race.participants.map((participant, index) => {
    const canceled = row[index] === couponValues.CANCELED;
    const isLocked = lockedIndicies ? lockedIndicies[index] : false;
    const isSelected = selectedParticipantId === participant.participantId;
    if (systemType !== systemTypes.RESULT && participant.additionalDistance !== undefined) {
      if (index === 0 && participant.additionalDistance !== 0) {
        firstOfAdditionalDistance.push(participant.additionalDistance);
        participant.showAdditionalDistance = true;
      }

      if (race.participants[index - 1] && race.participants[index - 1].additionalDistance !== participant.additionalDistance) {
        firstOfAdditionalDistance.push(participant.additionalDistance);
        participant.showAdditionalDistance = true;
      }
    }
    return React.createElement(Fragment, {
      key: "participant_".concat(participant.participantNumber)
    }, systemType !== systemTypes.RESULT && participant.showAdditionalDistance && React.createElement("div", {
      className: "coupon-additional-distance-holder"
    }, React.createElement("span", {
      className: "coupon-additional-distance"
    }, "Till\xE4gg", ' ', participant.additionalDistance, ' ', "meter")), React.createElement("div", {
      className: "coupon-list-item ".concat(isSelected ? 'selected' : '', " ").concat(listItemClass),
      key: participant.participantId
    }, systemType === systemTypes.UNIT_COMBINED && React.createElement(UnitCombinedParticipant, {
      canceled: canceled,
      index: index,
      isDisabled: isDisabled,
      participant: participant,
      silksFormattedDate: silksFormattedDate,
      toggleIndex: toggleIndex,
      value: row[index]
    }), systemType === systemTypes.UNIT_COMBINED_UNORDERED && React.createElement(UnitCombinedUnorderedParticipant, {
      canceled: canceled,
      index: index,
      isDisabled: isDisabled,
      participant: participant,
      silksFormattedDate: silksFormattedDate,
      toggleIndex: toggleIndex,
      value: row[index]
    }), systemType === systemTypes.TOP_RANK && React.createElement(TopRankParticipant, {
      canceled: canceled,
      index: index,
      isDisabled: isDisabled,
      participant: participant,
      silksFormattedDate: silksFormattedDate,
      toggleIndexRank: toggleIndexRank,
      value: getIndexRanksAsBoolArray(index)
    }), systemType === systemTypes.WHEEL && React.createElement(WheelParticipant, {
      canceled: canceled,
      index: index,
      isDisabled: isDisabled,
      isLocked: isLocked,
      participant: participant,
      silksFormattedDate: silksFormattedDate,
      toggleIndexBase: toggleIndexBase,
      value: getIndexAsObject(index)
    }), systemType === systemTypes.RESULT && React.createElement(ResultParticipant, {
      canceled: canceled,
      index: index,
      participant: participant,
      race: race,
      silksFormattedDate: silksFormattedDate,
      value: getIndexAsObject(index)
    }), systemType === systemTypes.TOP_RANK_PIX && React.createElement(TopRankPixParticipant, {
      canceled: canceled,
      disabledRankIndices: disabledRankIndices,
      disabledRanks: getDisabledRanksAsBoolArray(index),
      firstPlaceIsPicked: getFirstPlaceIsPicked(index),
      index: index,
      isDisabled: isDisabled,
      isPixPick: isPixPick,
      isXpertenFetched: xpertenFetched,
      participant: participant,
      silksFormattedDate: silksFormattedDate,
      singleOnFirstPosition: getSingleOnFirstPosition(),
      toggleIndexRank: toggleIndexRank,
      toggleSingleOnFirstPosition: toggleSingleOnFirstPosition,
      value: getIndexRanksAsBoolArray(index)
    })));
  });
};
const renderCouponActions = engine => {
  const buttons = [];
  const clearAll = engine.actions.clearAll;
  const hasAnySet = engine.selectors.hasAnySet();
  const clearAllBtn = React.createElement(Button, {
    className: "coupon-btn-action btn-clear-racing",
    disabled: !hasAnySet,
    inverted: true,
    key: "clearall",
    onClick: () => clearCoupon(clearAll),
    title: "Rensa",
    transparent: true
  }, React.createElement(ReactIcon, {
    class: "coupon-action-icon",
    icon: "dustbin"
  }));
  buttons.push(clearAllBtn);
  if (engine.systemType === systemTypes.WHEEL) {
    const toggleAllExtras = engine.actions.toggleAllExtras;
    const isFullWheel = engine.selectors.isFullWheel();
    const fullWheelBtn = React.createElement(Button, {
      className: "coupon-btn-action btn-clear-racing",
      inverted: !isFullWheel,
      key: "checkallx",
      onClick: () => toggleAllExtras(),
      title: "V\xE4lj alla",
      transparent: !isFullWheel
    }, React.createElement(ReactIcon, {
      class: "coupon-action-icon",
      icon: "checkmark"
    }));
    buttons.push(fullWheelBtn);
  }
  return buttons;
};
const handleHelpButtonClick = (e, name) => {
  if (svs.racing_game.data.racingconfig.helpTexts && svs.racing_game.data.racingconfig.helpTexts[name]) {
    const title = svs.racing_game.data.racingconfig.helpTexts[name].title;
    const text = svs.racing_game.data.racingconfig.helpTexts[name].body;
    const contextDialog = new svs.components.dialog.Contextual({
      branding: svs.components.dialog.branding.SPORT,
      attachTo: e.currentTarget,
      zIndex: 1100,
      title,
      message: [{
        type: svs.components.dialog.message.TEXT,
        text
      }]
    });
    svs.components.dialog.api.add(contextDialog);
  }
};
const renderCouponHeader = (systemType, isNotYetOpen) => {
  switch (systemType) {
    case systemTypes.RESULT:
      return isNotYetOpen ? React.createElement("span", null, "H\xE4star") : React.createElement("span", null, "Placering");
    case systemTypes.WHEEL:
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: "coupon-header-wheel"
      }, React.createElement("div", {
        className: "coupon-header-help"
      }, React.createElement(ReactIconButton, {
        className: "padding-xs-h align-center coupon-header-help-btn",
        onClick: e => handleHelpButtonClick(e, 'system_wheel_base')
      }, React.createElement(ReactIcon, {
        color: "fc-sport",
        icon: "help",
        size: "200"
      }))), React.createElement("span", null, "U-H\xE4st")), React.createElement("div", {
        className: "coupon-header-wheel"
      }, React.createElement("div", {
        className: "coupon-header-help"
      }, React.createElement(ReactIconButton, {
        className: "padding-xs-h coupon-header-help-btn",
        onClick: e => handleHelpButtonClick(e, 'system_wheel_extra')
      }, React.createElement(ReactIcon, {
        color: "fc-sport",
        icon: "help",
        size: "200"
      }))), React.createElement("span", null, "H\xE4star")));
    default:
      return React.createElement("span", null, "H\xE4star");
  }
};
const clearCoupon = cb => {
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.SPORT,
    icon: 'dustbin',
    type: svs.components.dialog.type.INFO,
    title: 'Rensa kupong',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Vill du rensa dina val i kupongen?'
    }],
    actions: [{
      title: 'Avbryt'
    }, {
      title: 'Rensa',
      callback: () => {
        cb();
        svs.components.dialog.api.close();
      }
    }]
  }));
};
const Coupon = _ref7 => {
  let {
    isDisabled
  } = _ref7;
  const {
    engine,
    race
  } = useContext(PlayContext);
  const [isExpanded, setIsExpanded] = useState(false);
  const systemType = engine.systemType;
  const gameType = engine.gameType;
  const isResult = systemType === systemTypes.RESULT;
  const isNotYetOpen = raceNotYetOpen(race);
  const topRankClass = systemType === systemTypes.TOP_RANK || systemTypes.TOP_RANK_PIX ? ' top-rank' : '';
  const listItemClass = getCouponItemSystemClass(systemType, race);
  const navState = useNavigationState();
  const selectedParticipantId = parseInt(navState.participantId, 10);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coupon-holder"
  }, React.createElement("div", {
    className: "coupon".concat(topRankClass)
  }, React.createElement("div", {
    className: "coupon-header"
  }, renderCouponHeader(systemType, isNotYetOpen)), renderParticipants(race, engine, isDisabled, selectedParticipantId), !isResult && React.createElement("div", {
    className: "coupon-actions-holder padding-top"
  }, React.createElement("div", {
    className: "coupon-actions"
  }, renderCouponActions(engine)))), React.createElement(MiniMeta, {
    gait: race.gait,
    gameType: gameType,
    isExpanded: isExpanded,
    isResult: isResult,
    itemClass: listItemClass,
    meta: race.participantsMeta,
    participants: race.participants,
    setIsExpanded: setIsExpanded
  })), raceOpen(race) && React.createElement(SelectionSummary, {
    engine: engine,
    participants: race.participants
  }));
};
svs.racing_game.components.play.Coupon = Coupon;

 })(window);